export default "__VITE_ASSET__5aUJgcB6__"